import React from 'react';
import { View } from 'react-native';
import { Box, IBoxProps } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { useShouldShowClientNavBar } from '../../consumer/ClientNavBar/hooks/useShouldShowClientNavBar';
import { useResponsiveEffect } from '../../../hooks';
import ResponsiveLayout from '../../layouts/ResponsiveLayout';
import { StyleSeatLionIcon } from '../../ui/Icons/StyleSeatLionIcon';
import './BlackLionLayout.module.scss';

export type BlackLionLayoutProps = {
  loading?: boolean;
  containerStyles?: IBoxProps['style'];
  showHeader?: boolean;
};

const BlackLionLayout: React.FC<BlackLionLayoutProps> = ({
  children,
  containerStyles = {},
  loading = false,
  showHeader = false,
}) => {
  const is = useResponsiveEffect();
  const { shouldShowClientNav } = useShouldShowClientNavBar();

  return (
    <ResponsiveLayout
      showHeader={showHeader || is.desktop}
      showClientNavBar={shouldShowClientNav}
    >
      {!is.desktop ? (
        <View styleName="black-lion-layout__container" style={containerStyles}>
          {loading ? null : children}
        </View>
      ) : (
        <Box styleName="black-lion-layout__backdrop" testID="black-lion-layout">
          {loading ? null : (
            <React.Fragment>
              <Box
                styleName="black-lion-layout__container"
                style={containerStyles}
              >
                {children}
              </Box>
              <Box styleName="black-lion-layout__logo-container">
                <StyleSeatLionIcon
                  height={144}
                  width={144}
                  color={colors.whiteWash}
                />
              </Box>
            </React.Fragment>
          )}
        </Box>
      )}
    </ResponsiveLayout>
  );
};

export default BlackLionLayout;
